<template>
  <div class="main" style="margin: 0">
    <dados-proposta :active="2" />
    <main class="container alianca-content">
      <section class="row">
        <div class="main-content col-12">
          <div id="cadastrar">

            <transition name="fade">
              <div id="step-1" class="multi-step-form active-step" v-if="etapa==='step-9'">
                <div class="d-flex align-content-center">
                  <p><img
                        src="../assets/arrow-left.svg"
                        alt="Voltar etapa"
                        @click.prevent="backtodadosbeneficiario()"
                      /></p>
                </div>
                <div class="align-flex-title" style="margin-top: -58px">
                  <h3>{{ nome }}, estamos quase finalizando</h3>
                </div>
                <div class="div-chamada-cadastro">
                  <p class="subhead-dps">Agora é hora de responder às perguntas sobre sua saúde.<br/> Tire uns minutos para completar essa parte com bastante atenção.<br/> Antes disso, leia a orientação da ANS (Agência Nacional de Saúde). </p>
                  <p class="subhead-dps-mobile" style="display: none">Agora é hora de responder às perguntas sobre sua saúde. Tire uns minutos para completar essa parte com bastante atenção. Antes disso, leia a orientação da ANS (Agência Nacional de Saúde). </p>
                </div>
                <div class="consentimento-dps-div" style="margin-top: 186px">
                  <b class="consentimento-dps">Li e concordo com a <a class="link-consentimento-dps" v-b-modal.modal-carta-beneficiario>carta de orientação ao beneficiário</a> da ANS. <input type="checkbox" class="form-check-input" v-model="consentimentodps"></b>
                  <div class="row">
                    <div @click="setEtapa('step-9','step-10')">
                      <b-button class="btn-alianca btn-next btn-next-continuar-dps" :class="{ 'btn-clicked': consentimentodps === true }" :disabled="!consentimentodps">CONFIRMAR E CONTINUAR</b-button>
                      <b-button class="btn-alianca btn-next btn-icon-next" :class="{ 'btn-clicked-icon': consentimentodps === true }" :disabled="!consentimentodps"><font-awesome-icon icon="angle-right" class="icon-arrow-right" /></b-button>
                    </div>
                  </div> 
                  <b-modal id="modal-carta-beneficiario">
                    <template #modal-header="{ close }">
                      <div style="margin: 0">
                        <h5 class="title-modal">Carta de orientação ao <span style="color: #A01D22">beneficiário</span></h5>
                      </div>
                      <div style="margin: 0">
                        <b-button class="close btn-close btn-modais-nohover" aria-label="Close" @click="close()">×</b-button>
                      </div>
                    </template>
                    <div class="modal-dps-div" style="max-height: 350px; overflow-y: auto;">
                      <p>
                        Prezado(a) Beneficiário(a),
                      </p>

                      <p>
                        A Agência Nacional de Saúde Suplementar (ANS), instituição que regula as atividades das operadoras de planos privados de assistência à saúde, e tem como missão defender o interesse público vem, por meio desta, prestar informações para o preenchimento da DECLARAÇÃO DE SAÚDE.
                      </p>
                      
                      <p>
                        <b>• O QUE É A DECLARAÇÃO DE SAÚDE?</b><br/>
                        <span>É o formulário que acompanha o Contrato do Plano de Saúde, onde o beneficiário ou seu representante legal deverá informar as doenças ou lesões preexistentes que saiba ser portador ou sofredor no momento da contratação do plano. Para o seu preenchimento, o beneficiário tem o direito de ser orientado, gratuitamente, por um médico credenciado/referenciado pela operadora. Se optar por um profissional de sua livre escolha, assumirá o custo desta opção.</span>
                      </p>

                      <p>
                        Portanto, se o beneficiário (você) toma medicamentos regularmente, consulta médicos por problema de saúde do qual conhece o diagnóstico, fez qualquer exame que identificou alguma doença ou lesão, esteve internado ou submeteu-se a alguma cirurgia, DEVE DECLARAR ESTA DOENÇA OU LESÃO.
                      </p>

                        <b>AO DECLARAR AS DOENÇAS E/OU LESÕES QUE O BENEFICIÁRIO SAIBA SER PORTADOR NO MOMENTO DA CONTRATAÇÃO</b><br/>
                        <p>A operadora NÃO poderá impedi-lo de contratar o plano de saúde. Caso isto ocorra, encaminhe a denúncia à ANS.</p>

                        <p>A operadora deverá oferecer: cobertura total ou COBERTURA PARCIAL TEMPORÁRIA (CPT), podendo ainda oferecer o Agravo, que é um acréscimo no valor da mensalidade, pago ao plano privado de assistência à saúde, para que se possa utilizar toda a cobertura contratada, após os prazos de carências contratuais.</p>

                        <p>No caso de CPT, haverá restrição de cobertura para cirurgias, leitos de alta tecnologia (UTI, unidade coronariana ou neonatal) e procedimentos de alta complexidade – PAC (tomografia, ressonância, etc. *) EXCLUSIVAMENTE relacionados à doença ou lesão declarada, até 24 meses, contados desde a assinatura do contrato. Após o período máximo de 24 meses da assinatura contratual, a cobertura passará a ser integral de acordo com o plano contratado.</p>

                        <p>NÃO haverá restrição de cobertura para consultas médicas, internações não cirúrgicas, exames e procedimentos que não sejam de alta complexidade, mesmo que relacionados à doença ou lesão preexistente declarada, desde que cumpridos os prazos de carências estabelecidas no contrato.</p>

                      <p class="single-space">
                        Não caberá alegação posterior de omissão de informação na Declaração de Saúde por parte da operadora para esta doença ou lesão.
                      </p>

                      <p>
                        AO NÃO DECLARAR AS DOENÇAS E/OU LESÕES QUE O BENEFICIÁRIO SAIBA SER PORTADOR NO MOMENTO DA CONTRATAÇÃO:<br/>
                        A operadora poderá suspeitar de omissão de informação e, neste caso, deverá comunicar imediatamente ao beneficiário, podendo oferecer CPT, ou solicitar abertura de processo administrativo junto à ANS, denunciando a omissão da informação.
                      </p>

                      <p>Comprovada a omissão de informação pelo beneficiário, a operadora poderá RESCINDIR o contrato por FRAUDE e responsabilizá-lo pelos procedimentos referentes a doença ou lesão não declarada.</p>

                      <p>Até o julgamento final do processo pela ANS, NÃO poderá ocorrer suspensão do atendimento nem rescisão do contrato. Caso isto ocorra, encaminhe a denúncia à ANS.</p>
                      <p>
                        ATENÇÃO! Se a operadora oferecer redução ou isenção de carência, isto não significa que dará cobertura assistencial para as doenças ou lesões que o beneficiário saiba ter no momento da assinatura contratual. Cobertura Parcial Temporária - CPT - NÃO é carência!<br/>
                        Portanto, o beneficiário não deve deixar de informar se possui alguma doença ou lesão ao preencher a Declaração de Saúde!
                      </p>
                      <p>Para consultar a lista completa de procedimentos de alta complexidade – PAC, acesse o Rol de Procedimentos e Eventos em Saúde da ANS no endereço eletrônico: www.ans.gov.br - Perfil Beneficiário . Em caso de dúvidas, entre em contato com a ANS pelo telefone 0800-701-9656 ou consulte a página da ANS - www.ans.gov.br - Perfil Beneficiário.</p>
                    </div>
                    <template #modal-footer="{ close }">
                      <div style="margin: 0">
                        <b-button class="btn-alianca pesquisar-planos btn-next-dps" @click="close(); setConsentimentodps();">LI E CONCORDO COM AS INFORMAÇÕES</b-button>
                      </div>
                    </template>
                  </b-modal>       
                </div>
              </div>
            </transition>

            <transition name="fade">
              <div id="step-10" class="multi-step-form active-step" v-if="etapa==='step-10'">
                <div class="d-flex align-content-center">
                  <p><img
                        src="../assets/arrow-left.svg"
                        alt="Voltar etapa"
                        @click.prevent="prevEtapa('step-9')"
                      /></p>
                </div>
                <div class="align-flex-title" style="margin-top: -58px; margin-bottom: 30px;">
                  <h3>Preencher a Declaração de Saúde</h3>
                </div>

                <div v-for="q in [0 , 1]" :key="q" class="row dps-item">
                  <p><b>{{ dpsquestoes[q].pergunta }}</b></p>
                  <div class="row">
                    <b-col cols="6">
                      {{ nomefull }}
                    </b-col>
                    <b-col cols="6" v-if="dpsquestoes[q].observacao == 'text'">
                      <b-form-input v-mask="['#,##']" v-if="q==1" placeholder="Digite aqui" v-model="dps[q][0].valor" ></b-form-input>
                      <b-form-input v-mask="['##','###' ]" v-else placeholder="Digite aqui" v-model="dps[q][0].valor" ></b-form-input>
                    </b-col>
                  </div>
                  <div v-for="(dep, i) in dependentes" :key="i" class="row">
                    <b-col cols="6">
                      {{ dep.NomeDep }}
                    </b-col>
                    <b-col cols="6" v-if="dpsquestoes[q].observacao == 'text'">
                      <b-form-input v-mask="['#,##']" v-if="q==1" placeholder="Digite aqui" v-model="dps[q][i+1].valor" ></b-form-input>
                      <b-form-input v-mask="['##','###' ]" v-else placeholder="Digite aqui" v-model="dps[q][i+1].valor" ></b-form-input>
                    </b-col>
                  </div>

                  <!-- TESTE VALIDAÇÃO -->
                  <div v-if="errors.length && q == 1" class="row dps-quest-inner dps-buttons" style="justify-content: center"> 
                    <b v-for="erro in errors" :key="erro">{{ erro }}</b><br>                   
                  </div> 
                  <!-- TESTE VALIDAÇÃO -->
                  <div v-if="q == 1" class="row dps-quest-inner dps-buttons" style="justify-content: flex-end; padding: 0">
                    <b-button class="btn-nova-dps" style="width: 197px; margin-top: 30px; margin-left: 0;" @click="startRealDPS()">
                      Proximo
                      <img src="../assets/dps-proximo.svg" alt="Avançar" style="position: relative; margin-right: -40px; margin-left: 40px;" />
                    </b-button>
                  </div>
                </div>
              </div>
            </transition>

            <transition name="fade">
              <div id="step-11" class="multi-step-form active-step" v-if="etapa==='step-11'">
                <div class="d-flex align-content-center">
                  <p><img
                        src="../assets/arrow-left.svg"
                        alt="Voltar etapa"
                        @click.prevent="prevEtapa('step-10')"
                      /></p>
                </div>
                <div class="align-flex-title" style="margin-top: -58px; margin-bottom: 30px;">
                  <h3>Preencher a Declaração de Saúde</h3>
                </div>
                <div class="div-chamada-cadastro">
                  <p class="subhead-dps">Responda as perguntas abaixo levando em consideração <b>você e seus <br/> dependentes. Marque sim</b> se pelo menos um de vocês tiveram alguma doença <br/> e <b>digite</b> qual.</p>
                  <p class="subhead-dps-mobile" style="display: none">Responda as perguntas abaixo levando em consideração você e seus dependentes. Marque sim se pelo menos um de vocês tiveram alguma doença e digite qual.</p>
                </div>
                <div class="progress-dps-bar" style="margin: 0; margin-top: 32px;">
                  <div class="progress-text-div">
                    <span class="text-progress-bar">Etapa {{ etapaatualdps }} / {{ etapasdps }}</span>
                    <span class="percent-progress-bar">{{ (( etapaatualdps / etapasdps ) * 100 ).toFixed(2) }} %</span>
                  </div>
                  <progress id="dps-progress" :value="dpsprogress" max="100"></progress>
                </div>
                

                <div v-for="(quest, q) in dpsquestoes" :key="q" :id="'questao-' + q" class="row dps-item">
                  <template v-if="q >= qvisible && q < (qvisible + 6)">
                    <div class="row dps-quest-inner" v-if="quest.pergunta.match(/(1 – Idade)/gmi)">
                      <b-col cols="10">
                        <p><b>{{ quest.pergunta }}</b></p>
                      </b-col>
                      <b-col cols="12">
                        <div class="box-beneficiarios-nova-dps" style="margin: 0">
                          <b-col cols="8">
                            {{ nomefull }}
                          </b-col>
                          <b-col cols="4">
                            {{calcIdadeTitular}} anos
                            <input class="hidden" :placeholder="calcIdadeTitula" :value="dps[q][0].observacao = calcIdadeTitular" >
                            <input class="hidden" type="text" :value="dps[q][0].valor = 'Sim'" >
                          </b-col>
                        </div>
                      </b-col>
                      <b-col cols="12" v-for="(dep, i) in pesoAlturaDependentes" :key="i">
                        <div class="box-beneficiarios-nova-dps" style="margin: 0">
                          <b-col cols="8">
                            {{ dep.nome }}
                          </b-col>
                          <b-col cols="4">
                            {{dep.datanasc}} anos
                            <input class="hidden" :placeholder="dep.datanasc" :value="dps[q][i+1].observacao = dep.datanasc" >
                            <input class="hidden" type="text" :value="dps[q][i+1].valor = 'Sim'" >
                          </b-col>
                        </div>
                      </b-col>
                    </div>
                  </template>
                </div>

                <div v-for="(quest, q) in dpsquestoes" :key="q" :id="'questao-' + q" class="row dps-item">
                  <template v-if="q >= qvisible && q < (qvisible + 6)">
                    <div class="row dps-quest-inner dps-perguntas" v-if="quest.pergunta.match(/(2 – Peso)/gmi)">
                      <b-col cols="10">
                        <p><b>{{ quest.pergunta }}</b></p>
                      </b-col>
                      <b-col cols="12">
                        <div class="box-beneficiarios-nova-dps" style="margin: 0">
                          <b-col cols="8">
                            {{ nomefull }}
                          </b-col>
                          <b-col cols="4">
                            {{pesoTitular.valor}} Kg
                            <input  class="hidden" type="text" :value="dps[q][0].observacao = pesoTitular.valor">
                            <input class="hidden" type="text" :value="dps[q][0].valor = 'Sim'" >
                          </b-col>
                        </div>
                      </b-col>
                      <b-col cols="12" v-for="(dep, i) in pesoAlturaDependentes" :key="i">
                        <div class="box-beneficiarios-nova-dps">
                          <b-col cols="8">
                            {{ dep.nome }}
                          </b-col>
                          <b-col cols="4">
                            {{dep.peso}} Kg
                            <input  class="hidden" type="text" :value="dps[q][i+1].observacao = dep.peso">
                            <input class="hidden" type="text" :value="dps[q][i+1].valor = 'Sim'" >
                          </b-col>
                        </div>
                      </b-col>
                    </div>
                  </template>
                </div>

                <div v-for="(quest, q) in dpsquestoes" :key="q" :id="'questao-' + q" class="row dps-item">
                  <template v-if="q >= qvisible && q < (qvisible + 6)">
                    <div class="row dps-quest-inner dps-perguntas" v-if="quest.pergunta.match(/(3 – Altura)/gmi)">
                      <b-col cols="10">
                        <p><b>{{ quest.pergunta }}</b></p>
                      </b-col>
                      <b-col cols="12">
                        <div class="box-beneficiarios-nova-dps" style="margin: 0">
                          <b-col cols="8">
                            {{ nomefull }}
                          </b-col>
                          <b-col cols="4">
                            {{alturaTitular.valor}}
                            <input class="hidden" type="text" :value="dps[q][0].observacao = alturaTitular.valor">
                            <input class="hidden" type="text" :value="dps[q][0].valor = 'Sim'" >
                          </b-col>
                        </div>
                      </b-col>
                      <b-col cols="12" v-for="(dep, i) in pesoAlturaDependentes" :key="i">
                        <div class="box-beneficiarios-nova-dps">
                          <b-col cols="8">
                            {{ dep.nome }}
                          </b-col>
                          <b-col cols="4">
                            {{dep.altura}}
                            <input class="hidden" type="text" :value="dps[q][i+1].observacao = dep.altura">
                            <input class="hidden" type="text" :value="dps[q][i+1].valor = 'Sim'" >
                          </b-col>
                        </div>
                      </b-col>
                    </div>
                  </template>
                </div>

                <div v-for="(quest, q) in dpsquestoes" :key="q" :id="'questao-' + q" class="row dps-item">
                  <template v-if="q >= qvisible && q < (qvisible + 6)">
                    <div class="row dps-quest-inner dps-perguntas" v-if="quest.pergunta.match(/(4 – IMC)/gmi)">
                      <b-col cols="10">
                        <p><b>{{ quest.pergunta }}</b></p>
                      </b-col>
                      <b-col cols="12">
                        <div class="box-beneficiarios-nova-dps" style="margin: 0">
                          <b-col cols="8">
                            {{ nomefull }}
                          </b-col>
                          <b-col cols="4">
                            {{
                              (pesoTitular.valor / 
                              (alturaTitular.valor.replace(',', '.') * alturaTitular.valor.replace(',', '.'))).toFixed(2)
                            }}

                            <input class="hidden" type="text" :value="dps[q][0].observacao = (pesoTitular.valor / 
                                (alturaTitular.valor.replace(',', '.') * alturaTitular.valor.replace(',', '.'))).toFixed(2)" >
                                <input class="hidden" type="text" :value="dps[q][0].valor = 'Sim'" >
                          </b-col>
                        </div>
                      </b-col>
                      <b-col cols="12" v-for="(dep, i) in pesoAlturaDependentes" :key="i">
                          <div class="box-beneficiarios-nova-dps">
                            <b-col cols="8">
                              {{ dep.nome }}
                            </b-col>
                            <b-col cols="4">
                              {{
                                (dep.peso / 
                                (dep.altura.replace(',', '.') * dep.altura.replace(',', '.'))).toFixed(2)
                              }}
                              <input class="hidden" type="text" :value="dps[q][i+1].observacao = (dep.peso / 
                                (dep.altura.replace(',', '.') * dep.altura.replace(',', '.'))).toFixed(2)" >
                                <input class="hidden" type="text" :value="dps[q][i+1].valor = 'Sim'" >
                              
                            </b-col>
                          </div>
                      </b-col>
                    </div>
                  </template>
                </div>

                <div v-for="(quest, q) in dpsquestoes" :key="q" :id="'questao-' + q" class="row dps-item">
                  <template v-if="q >= qvisible && q < (qvisible + 6)"> 
                    <div class="row dps-quest-inner" v-if="quest.pergunta.match(/(– Idade)/gmi)">
                    </div>
                    <div class="row dps-quest-inner" v-else-if="quest.pergunta.match(/(– Peso)/gmi)">
                    </div>
                    <div class="row dps-quest-inner" v-else-if="quest.pergunta.match(/(– Altura)/gmi)">
                    </div>
                    <div class="row dps-quest-inner" v-else-if="quest.pergunta.match(/(– IMC)/gmi)">
                    </div>
                    <div class="row dps-quest-inner" v-else>
                      <b-col cols="10">
                        <p><b>{{ quest.pergunta }}</b></p>
                      </b-col>
                      <b-col cols="2" class="toggle-dps">
                        <toggle-button 
                          color="#1DA090"
                          :width="80"
                          :height="30"
                          @change="ShowNameOptions(q)"
                          :value="historyquest[q].exibir"
                          :labels="{checked: 'Sim', unchecked: 'Não'}"
                        />
                      </b-col>
                      <b-col cols="12" :id="'showquest-' + q" v-show="historyquest[q].exibir">
                        Indique quem:
                        <div class="box-beneficiarios-nova-dps" style="margin: 0">
                          <b-col cols="6">
                            <input class="form-check-input" type="checkbox" @click="showAuxDesc(q, 0)" :checked="historyquest[q].ben[0]"> {{ nomefull }}
                          </b-col>
                          <b-col cols="6" :id="'addquest-' + q + '-p-' + 0" v-show="historyquest[q].ben[0]">
                            <b-form-input placeholder="Informe aqui" v-model="dps[q][0].observacao"></b-form-input>
                          </b-col>
                        </div>
                        <div v-for="(dep, i) in dependentes" :key="i" class="box-beneficiarios-nova-dps">
                          <b-col cols="6">
                            <input class="form-check-input" type="checkbox" @click="showAuxDesc(q, (i + 1))" :checked="historyquest[q].ben[i+1]"> {{ dep.NomeDep }}
                          </b-col>
                          <b-col cols="6" :id="'addquest-' + q + '-p-' + (i + 1)" v-show="historyquest[q].ben[i+1]">
                            <b-form-input placeholder="Informe aqui" v-model="dps[q][i+1].observacao"></b-form-input>
                          </b-col>
                        </div>
                      </b-col>
                    </div>

                    <!-- TESTE VALIDAÇÃO -->
                    <div v-if="errors.length && q == (qvisible + 6 - 1)" class="row dps-quest-inner dps-buttons" style="justify-content: center"> 
                      <b v-for="erro in errors" :key="erro">{{ erro }}</b><br>                   
                    </div> 
                    <!-- TESTE VALIDAÇÃO -->
                    <div v-if="q == (qvisible + 6 - 1) || q == ( dpsquestoes.length - 1)" class="row dps-quest-inner dps-buttons" style="justify-content: space-between">
                      <b-button class="btn-nova-dps" style="width: 197px; margin-top: 30px; margin-left: 0;" @click="backQuestion(q)">
                        <img src="../assets/dps-anterior.svg" alt="Voltar" style="position: relative; margin-right: 50px; margin-left: -50px;" /> Voltar
                      </b-button>
                      <b-button class="btn-nova-dps" v-if="q < ( dpsquestoes.length - 1)" style="width: 197px; margin-top: 30px; margin-left: 0;" @click="nextQuestion(q)">
                        Proximo
                        <img src="../assets/dps-proximo.svg" alt="Avançar" style="position: relative; margin-right: -40px; margin-left: 40px;" />
                      </b-button>
                    </div>

                    <div class="finaliza-dps-quests" v-if="q == ( dpsquestoes.length - 1)" style="margin-top: 100px">
                      <div class="texto-dps" style="margin: 0!important; padding-left: 15px; padding-right: 15px; text-align: center"><b class="consentimento-dps">Estou de acordo que as informações fornecidas são verdadeiras. <input type="checkbox" class="form-check-input" v-model="vericidadeinfos"></b></div>
                      <div class="row">
                        <div @click="gotopagamentos()">
                          <b-button class="btn-alianca btn-next btn-next-continuar-dps s" :class="{ 'btn-clicked': vericidadeinfos === true }" :disabled="!vericidadeinfos">CONFIRMAR E CONTINUAR</b-button>
                          <b-button class="btn-alianca btn-next btn-icon-next" :class="{ 'btn-clicked-icon': vericidadeinfos === true }" :disabled="!vericidadeinfos"><font-awesome-icon icon="angle-right" class="icon-arrow-right" /></b-button>
                        </div>
                      </div> 
                    </div>
                  </template>
                </div>
              </div>
            </transition>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<style>
  .hidden {
    visibility: hidden;
    height: 10px;
    position: absolute;
  }
  .dps-perguntas{
    margin-top: 0px;
  }
</style>

<script>
  import obterPerguntasDPS from "../services/obterPerguntasDPS"
  import store from "../store"
  import {mask} from 'vue-the-mask'
  import moment from 'moment-timezone'

  console.log(store, obterPerguntasDPS, mask)

  export default {
    name: 'DPS',
    mixins: [],
    directives:{
      mask
    },
    components: {},
    methods: {
      calculateAge(date) {
        let currentDate = new Date();
        let birthDate = new Date(date);
        let difference = currentDate - birthDate;
        let age = Math.floor(difference / 31557600000);
        return age;
      },
      formatPrice(value) {
        const val = Number(value.replace(",", "."));
        if (!val) return '00,00';
        const valueString = val.toFixed(2).replace(".", ",");
        return valueString.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      },
      setConsentimentodps(){
        this.consentimentodps = true
      },
      onKeydown: function(e) {
        if (
          // permite somente numeros
          (e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode >= 96 && e.keyCode <= 105) ||
          // permite teclas lado direito, esquerdo, delete, backspace, tab e enter
          /^(8|9|13|46|37|39|17)$/.test(e.keyCode) ||
          // permite ctrl+ c,v,x,a,z
          /^(67|86|88|65|90)$/.test(e.keyCode) && e.ctrlKey
        ) return;
        e.preventDefault();
        e.stopPropagation();        
      },
      validaQuestao(q){
        if(this.dps[q][0].observacao == 'text'){
          if(!this.dps[q][0].valor){
            this.errors.push('Preencha corretamente a questão do titular acima')
            return false
          }
        } else {
          if(this.dps[q][0].valor == 'Sim'){
            if(!this.dps[q][0].observacao){
              this.errors.push('Preencha corretamente as observações do titular acima')
              return false
            }
          } 
        }

        for(let i = 0; i < this.dependentes.length; i++) {
          if(this.dps[q][i+1].observacao == 'text'){
            if(!this.dps[q][i+1].valor){
              this.errors.push('Preencha corretamente as questões dos dependentes acima')
              return false
            }
          } else {
            if(this.dps[q][i+1].valor == 'Sim'){
              if(!this.dps[q][i+1].observacao){
                this.errors.push('Preencha corretamente as observações dos dependentes acima')
                return false
              }
            } 
          }
        }

        this.optionaltura = this.dps[1].filter(res => res.pessoaid > 0)
        this.optionpeso = this.dps[0].filter(res => res.pessoaid > 0)
        return true
      },
      startRealDPS(){
        this.errors = []
        if (this.validaQuestao(0) && this.validaQuestao(1)) this.setEtapa('step-10','step-11')
      },
      backQuestion(q){
        if ((q - 5) == 2) this.prevEtapa('step-10')
        else {
          this.qvisible = this.qvisible - 6
          this.etapaatualdps--
          this.dpsprogress = Math.ceil( ( this.etapaatualdps / this.etapasdps ) * 100 )
        }
      },
      nextQuestion(q){
        q = q - 5
        if (q <= this.dpsquestoes.length){
          this.errors = []

          let validaok = true
          for (let i = 0; i < 6; i++) validaok = validaok && this.validaQuestao((q + i))

          if (validaok){
            if(q == this.dpsquestoes.length){
              this.showfinalizadps = true
            } else {
              this.qvisible = this.qvisible + 6
              this.etapaatualdps++
              this.dpsprogress = Math.ceil( ( this.etapaatualdps / this.etapasdps ) * 100 )
            }
          }
        }
      },
      ShowNameOptions(q){
        let elem = document.getElementById('showquest-' + q)
        if (elem.style.display == 'block') elem.style.display = 'none'
        else elem.style.display = 'block'
        
        this.historyquest[q].exibir = !this.historyquest[q].exibir
      },
      AlwaysShowNameOptions(q){
        document.getElementById('showquest-' + q).style.display = 'block'
      },
      showAuxDesc(q, i){
        this.historyquest[q].ben[i] = !this.historyquest[q].ben[i]
        if (this.historyquest[q].ben[i]){
          this.dps[q][i].valor = 'Sim'
          this.dps[q][i].observacao = ''
        } else {
          this.dps[q][i].valor = 'Não'
          this.dps[q][i].observacao = ''
        }

        // Correção para perda de reatividade nas descrições de beneficiários
        let elem = document.getElementById('addquest-' + q + '-p-' + i)
        if (elem.style.display == 'block'){
          elem.style.display = 'none'
          // this.dps[q][i].valor = 'Não'
          // this.dps[q][i].observacao = ''
        } else {
          elem.style.display = 'block'
          // this.dps[q][i].valor = 'Sim'
          // this.dps[q][i].observacao = ''
        }
      },
      backtodadosbeneficiario(){
        // store.commit('mutAliancaObjDependentes', null)
        this.$router.push("dados-beneficiario")
      },
      gotopagamentos(){
        //if (this.validaCadastro()){
          document.getElementById('step-progress').value = 91.33
          store.commit("mutAliancaObjDPS", this.dps)
          store.commit("mutAliancaHistoryDPS", this.historyquest)
          this.$router.push("informacoes-pagamento")
        //}
      },
      prevEtapa(anterior) {
        this.etapa = anterior
        store.commit('mutAliancaProxEtapa', anterior)
      },
      async setEtapa(atual, prox){
        switch (atual) {
          case 'step-9':
            this.etapa = prox
            document.getElementById('step-progress').value = 85.01
            break;
          case 'step-10':
            this.etapa = prox
            document.getElementById('step-progress').value = 88.01
            break;
          case 'step-11':
            if (prox == 'end'){
              this.$router.push("login")
              this.etapa = prox
            }
            break;
        }  
      },
    },
    data(){
      return {
        nome: '',
        nomefull: '',
        consentimentodps: false,
        vericidadeinfos: false,
        dps: [],
        dpsquestoes: [
          { pergunta: "Qual seu peso? (Kg)", valor: '' , observacao: 'text' },
          { pergunta: "Qual sua altura? (Metros)", valor: '' , observacao: 'text' },
        ],
        historyquest: [],
        qvisible: 2,
        dependentes: [],
        etapa: 'step-9',
        errors: [],
        idadeTItular:'',
        datanasc: store.getters.getAliancaDataNasc,
        idadeDependentes:'',
        showfinalizadps: false,
        dpsprogress: 0,
        etapaatualdps: 0, 
        etapasdps: 0,
        pesoBeneficiarios:[],
        alturaBeneficiarios: [],
        optionaltura:[],
        optionpeso:[],
        calcImcTitular: '',
      }
    },
    computed: {
      calcIdadeTitular(){
        var data = this.datanasc;
        var dia  = data.split("/")[0];
        var mes  = data.split("/")[1];
        var ano  = data.split("/")[2];
        var dataFormatada = ano + '-' + ("0"+mes).slice(-2) + '-' + ("0"+dia).slice(-2);
        var resIdade = Math.floor(moment(new Date()).diff(moment(dataFormatada),'years',true));

        return resIdade;
      },

      pesoTitular(){
        let peso = this.dps[0].filter(res => res.pessoaid === 0);
        return peso[0]; 
      },

      alturaTitular(){
        var altura = '';
        for (var i = this.dps[1].length - 1; i >= 0; i--) {
          altura = this.dps[1][i]
        }
        return altura; 
      },

      pesoAlturaDependentes(){
        const optiondependentes = [];

        for (var i = this.dependentes.length - 1; i >= 0; i--) {

          let data = this.dependentes[i].DataNascDep.substr(6, 4) + 
          "/" +
          this.dependentes[i].DataNascDep.substr(3, 2) +
          "/" +
          this.dependentes[i].DataNascDep.substr(0, 2);

          let currentDate = new Date();
          let birthDate = new Date(data);
          let difference = currentDate - birthDate;
          let age = Math.floor(difference / 31557600000);

          optiondependentes.push({
            pessoaid: i + 1,
            datanasc: age,
            nome: this.dependentes[i].NomeDep,
          })
        }

        let alt = [];
        let peso = []

        for (var b = this.optionaltura.length - 1; b >= 0; b--) {
          alt.push({
            pessoaid: this.optionaltura[b].pessoaid,
            observacao: this.optionaltura[b].observacao,
            altura: this.optionaltura[b].valor,
          })
        }

        for (var c = this.optionpeso.length - 1; c >= 0; c--) {
          peso.push({
            pessoaid: this.optionpeso[c].pessoaid,
            observacao: this.optionpeso[c].observacao,
            peso: this.optionpeso[c].valor,
          })
        }

        let altura = alt.map(t1 => ({...t1, ...optiondependentes.find(t2 => t2.pessoaid === t1.pessoaid)}))

        let pesoAltura = peso.map(t1 => ({...t1, ...altura.find(t2 => t2.pessoaid === t1.pessoaid)}))

        return pesoAltura;
      },
    },
    watch: {
      calcImcTitular(){
        var altTitular = this.alturaTitular
        return altTitular;
      }
    },
    async mounted(){
      document.getElementById('step-progress').value = 78.69
      document.getElementById('step-progress-point1').classList.add("rounded-point-progress-ok")
      document.getElementById('step-progress-point2').classList.add("rounded-point-progress-ok")
      document.getElementById('step-progress-point3').classList.add("rounded-point-progress-ok")
      document.getElementById('globaletapa2').classList.remove("etapas-progresso-texto-disabled")
      document.getElementById('globaletapa3').classList.remove("etapas-progresso-texto-disabled")

      document.getElementsByClassName('dados-beneficiario-tab-item')[0].classList.add("dados-beneficiario-tab-dps")
    },
    async created() {
      let objdependentes = store.getters.getAliancaObjDependentes
      if (objdependentes != null){
        this.nome = store.getters.getAliancaNome.split(" ")[0]
        this.nomefull = store.getters.getAliancaNome
        this.dependentes = store.getters.getAliancaObjDependentes
        
        let operadoras = store.getters.getAliancaPlanosOperadoras

        let operadora_plano_selecionado = store.getters.getAliancaSelectedPlano.frontoperadoraid.operadoraprotheusid
        let codquestionario = ""

        for (let el in operadoras) {
          if (el == operadora_plano_selecionado) {
            codquestionario = operadoras[el].CODIGO_QUESTIONARIO
            console.log('codquestionario', codquestionario)
          } 
        }

        if (codquestionario != ""){
          let perguntas = await obterPerguntasDPS(codquestionario)
 
          for ( let i = 0; i < perguntas.length; i++ ) this.dpsquestoes.push({ pergunta: perguntas[i].DESCRICAO, valor: 'Não', observacao: '', cdper: perguntas[i].CD_PERGUNTA, codper: perguntas[i].CODIGO_PERGUNTA })

          let flagdpsimportada = store.getters.getAliancaObjDPS != null ? true : false
          if (!flagdpsimportada){

            for ( let pq = 0; pq < this.dpsquestoes.length; pq++ ){

              let dpsfinal = []
              dpsfinal.push({ pessoaid: 0, cdper: this.dpsquestoes[pq].cdper, codper: this.dpsquestoes[pq].codper, valor: this.dpsquestoes[pq].valor, observacao: this.dpsquestoes[pq].observacao })
              if (store.getters.getAliancaObjDependentes != null){
                for (let i = 0; i < this.dependentes.length; i++){
                  dpsfinal.push({ pessoaid: i + 1, cdper: this.dpsquestoes[pq].cdper, codper: this.dpsquestoes[pq].codper, valor: this.dpsquestoes[pq].valor, observacao: this.dpsquestoes[pq].observacao })
                }
              }
              this.dps[pq] = dpsfinal
            }

            for (let q = 2; q < this.dps.length; q++){
              this.historyquest[q] = { exibir: false, ben: [] }
              this.historyquest[q].ben.push(false)
              for (let b = 0; b < this.dependentes.length; b++) this.historyquest[q].ben.push(false)
            }
          } else {
            this.dps = store.getters.getAliancaObjDPS
            this.historyquest = store.getters.getAliancaHistoryDPS

            if (this.dps[0].length != (store.getters.getAliancaObjDependentes.length + 1)){
              for ( let pq = 0; pq < this.dpsquestoes.length; pq++ ){
                let dpsfinal = []
                dpsfinal.push({ pessoaid: 0, valor: this.dpsquestoes[pq].valor, observacao: this.dpsquestoes[pq].observacao })
                if (store.getters.getAliancaObjDependentes != null){
                  for (let i = 0; i < this.dependentes.length; i++){
                    dpsfinal.push({ pessoaid: i + 1, valor: this.dpsquestoes[pq].valor, observacao: this.dpsquestoes[pq].observacao })
                  }
                }
                this.dps[pq] = dpsfinal
              }

              for (let q = 2; q < this.dps.length; q++){
                this.historyquest[q] = { exibir: false, ben: [] }
                this.historyquest[q].ben.push(false)
                for (let b = 0; b < this.dependentes.length; b++) this.historyquest[q].ben.push(false)
              }
            }
          }

          this.etapaatualdps = 1
          this.etapasdps = Math.ceil(this.dps.length / 6)
          this.dpsprogress = Math.ceil( ( this.etapaatualdps / this.etapasdps ) * 100 )
        } else {
          alert("Erro ao encontrar o questionário da operadora")
          this.$router.push("dados-beneficiario")
        }
      } else {
        this.$router.push("dados-beneficiario")
      }
    }
  }
</script>